
if (typeof AJS !== "undefined") {
    __webpack_require__.p = AJS.contextPath() + "/s/d39c1b95-f663-40d2-8624-8e34aecbb8f5/_/download/resources/com.atlassian.auiplugin:assets-d39c1b95-f663-40d2-8624-8e34aecbb8f5/";
}
